module.exports = __webpack_public_path__ + "img/16.32c2ce6f.png";